module.exports = __webpack_public_path__ + "static/media/BG_1.a8697a81.png";